<template>
  <svg width="18" height="17" viewBox="0 0 18 17" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="9" cy="8.5" r="8" fill="#F9FAFB" />
    <rect x="1" y="0.5" width="16" height="16" rx="8" stroke="#D1D5DB" />
  </svg>
</template>
